import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { render } from "@testing-library/react";
import { Dropdown, Space, Table, Tag } from "antd";
import tagByStatus from "features/requestApproval/components/TagByStatus";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs"
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";

function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD-MM-YYYY" }) {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format(reFormat);
}

const WarningLetterTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onView = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
  isEmployee = false
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  function readMode(status, record) {
    let items = []
    if (String(status)?.toLowerCase?.() == 'Draft'?.toLowerCase?.()) {
      if (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|WARNING_LETTER") && !isEmployee) {
        items.push({
          key: "1",
          onClick: () => onEdit(record),
          label: `${t("action.edit")}`,
          icon: (
            <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
      if (roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|WARNING_LETTER") && !isEmployee) {
        items.push({
          key: "2",
          onClick: () => onDelete(record),
          label: `${t("action.delete")}`,
          icon: (
            <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
    }
    if ((roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST") && !isEmployee) || (isEmployee && roles.includes("ACCESS_EMPLOYEE|DOCUMENT|WARNING_LETTER"))) {
      items.push({
        key: "3",
        onClick: () => onView(record),
        label: `${t("action.view")}`,
        icon: (
          <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
        ),
      },)
    }
    return items || []
  }
  const columns = [
    {
      title: <div className="text-table">{t('workin_location.label.reqid')}</div>,
      dataIndex: "sequence",
      key: "sequence",
      sorter: true,
    },
    {
      title: <div className="text-table">{t('warning_letter.label.employee')}</div>,
      dataIndex: "employee",
      key: "employee",
      sorter: true,
      render: (_, record) => {
        if (i18n.language === "en") {
          return record?.warnedEmployee?.nameAndSurnameEn;
        }
        return record?.warnedEmployee?.nameAndSurname;
      },
    },
    {
      title: <div className="text-table">{t('employee.label.department')}</div>,
      dataIndex: "department",
      key: "department",
      sorter: true,
      render: (_, record) => {
        return i18n.language === 'en' ? record?.departmentId?.departmentNameEn : record?.departmentId?.departmentName
      },
    },
    {
      title: <div className="text-table">{t('warning_letter.label.company_regulations')}</div>,
      dataIndex: "companyRegulations",
      key: "companyRegulations",
      sorter: true,
      width: 200,
      render: (_, record) => {
        if (i18n.language === "en") {
          return record?.companyRegulations?.companyRegulationEn;
        }
        return record?.companyRegulations?.companyRegulation;
      },
    },
    {
      title: <div className="text-table">{t('warning_letter.label.date_of_incident')}</div>,
      dataIndex: "incidentDate",
      key: "incidentDate",
      sorter: true,
      render: (_, record) => {
        console.log(record);
        return record?.incidentDate ? formatDate({ dateString: record?.incidentDate, reFormat: i18n.language === "en" ? "DD MMM YYYY" : "DD MMMM BBBB" }) : "-"
      }

    },
    {
      title: <div className="text-table">{t('status.entity')}</div>,
      dataIndex: "requestStatus",
      key: "requestStatus",
      sorter: true,
      render: (text, record) => {
        let language = i18n.language == 'en' ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />
      }
    },
    roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|WARNING_LETTER") || roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|WARNING_LETTER") ? actionBar() : {}
  ];

  function actionBar() {
    if (!isEmployee) {
      return {
        title: "",
        key: "action",
        render: (_, record) => (
          <Space size="middle">
            <Dropdown
              menu={{
                items: readMode(_.approveStatusEn, record)
              }}
            >
              <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
            </Dropdown>
          </Space>
        ),
      }
    } else {
      return {}
    }
  }

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.warningLetterRequestId}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default WarningLetterTable;
